import { getData, getDataWithParams } from './profileService'

export const SECURE_SETUP_VARIANTS = Object.freeze({
  optimized: 'optimized',
})

export function isLegacyMobileSetupClient() {
  if (typeof window === 'undefined') {
    return false
  }

  if (window.location?.pathname?.startsWith('/webview/')) {
    return true
  }

  if (window.Android && typeof window.Android.getUserToken === 'function') {
    return true
  }

  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.iosBridge
  ) {
    return true
  }

  return false
}

export function shouldUseOptimizedSecureSetupVariant({
  preferOptimizedWebVariant = false,
} = {}) {
  return preferOptimizedWebVariant === true && !isLegacyMobileSetupClient()
}

export function getSecureSetupCustomParams({
  preferOptimizedWebVariant = false,
} = {}) {
  return shouldUseOptimizedSecureSetupVariant({
    preferOptimizedWebVariant,
  })
    ? `&variant=${encodeURIComponent(SECURE_SETUP_VARIANTS.optimized)}`
    : ''
}

export async function getSecureSetupData({
  preferOptimizedWebVariant = false,
} = {}) {
  if (
    !shouldUseOptimizedSecureSetupVariant({
      preferOptimizedWebVariant,
    })
  ) {
    return getData('/api/secure/setup')
  }

  return getDataWithParams('/api/secure/setup', {
    variant: SECURE_SETUP_VARIANTS.optimized,
  })
}

export async function compareSecureSetupData(apiParams = {}) {
  return getDataWithParams('/api/secure/setup/compare', apiParams)
}
